module.exports = __webpack_public_path__ + "img/depinx.e1a7f6a2.png";